import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Alert, Spinner } from '../components/shared';
import api from '../lib/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--ink)',
      backgroundImage: 'radial-gradient(ellipse 80% 60% at 30% 50%, rgba(45,212,191,0.05) 0%, transparent 60%)',
      padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        {/* Brand */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 600, color: 'var(--gold)', letterSpacing: '0.05em' }}>
            FUTURUM INNOVATION AWARDS
          </div>
        </div>

        <div className="card" style={{ padding: 36 }}>
          {!submitted ? (
            <>
              <div style={{ marginBottom: 28 }}>
                <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '1.75rem', fontWeight: 400 }}>Reset your password</h1>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginTop: 6, lineHeight: 1.6 }}>
                  Enter your registered email address and we will send you a reset link.
                </p>
              </div>

              {error && <div style={{ marginBottom: 20 }}><Alert type="error">{error}</Alert></div>}

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    className="form-input"
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-lg" disabled={loading} style={{ width: '100%', marginTop: 8 }}>
                  {loading ? <Spinner size={18} /> : <>Send Reset Link <ArrowRight size={16} /></>}
                </button>
              </form>
            </>
          ) : (
            <>
              <div style={{ textAlign: 'center', marginBottom: 24 }}>
                <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>📧</div>
                <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '1.75rem', fontWeight: 400, marginBottom: 12 }}>Check your email</h1>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', lineHeight: 1.7 }}>
                  If <strong style={{ color: 'var(--text-primary)' }}>{email}</strong> is registered with Futurum, you will receive a password reset link shortly.
                  Check your spam folder if it does not arrive within a few minutes.
                </p>
              </div>
              <Link to="/login" className="btn btn-ghost btn-lg" style={{ width: '100%', textAlign: 'center', textDecoration: 'none', display: 'block' }}>
                ← Back to login
              </Link>
            </>
          )}
        </div>

        <p style={{ textAlign: 'center', marginTop: 24, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
          <Link to="/login" style={{ color: 'var(--text-muted)' }}>← Back to login</Link>
        </p>
      </div>
    </div>
  );
}
